var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgN({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.85 23.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.45,0c.11,0,.21,0,.3.03v23.65c-.1.06-.21.09-.33.09H.64c-.35,0-.64-.29-.64-.64V1.22C0,.54.54,0,1.22,0h3.23Zm13.76,0c.35,0,.64.26.64.61v21.95c0,.67-.58,1.22-1.25,1.22h-3.14c-.26,0-.5-.02-.72-.1v-9.32s.05-.11.05-.21V.61c0-.35.29-.61.64-.61h3.78ZM5.79.99l6.95,12.09v9.61l-7-12.1V.91s.03.05.05.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN);
export default __webpack_public_path__ + "static/media/N.54578de045eab5d04de52dcaefbba030.svg";
export { ForwardRef as ReactComponent };